import React from 'react';
// App.css or a dedicated Canvas.css should be imported in App.js or here
// For this example, assuming App.css is imported in App.js and contains .canvas styles

const Canvas = ({ children }) => { // Destructure children
  return (
    <div className="canvas">
      {children} {/* Render children (sticky notes) */}
    </div>
  );
};

export default Canvas;
